function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassThru(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 48,
    viewBox: "0 0 86 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M79.0813 5.46341H5.55286V42.5366H79.0813V5.46341Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0813 43H5.55286C5.29644 43 5.08945 42.793 5.08945 42.5366V5.46341C5.08945 5.20699 5.29644 5 5.55286 5H79.0813C79.3377 5 79.5447 5.20699 79.5447 5.46341V42.5366C79.5447 42.793 79.3377 43 79.0813 43ZM6.01628 42.0732H78.6179V5.92683H6.01628V42.0732Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0325 8.55285H8.64229V39.4472H29.0325V8.55285Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0325 39.9106H8.64229C8.38587 39.9106 8.17888 39.7036 8.17888 39.4472V8.55285C8.17888 8.29642 8.38587 8.08943 8.64229 8.08943H29.0325C29.289 8.08943 29.496 8.29642 29.496 8.55285V39.4472C29.496 39.7036 29.289 39.9106 29.0325 39.9106ZM9.10571 38.9837H28.5691V9.01626H9.10571V38.9837Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3008 39.4472H32.122V8.55285H38.3008",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3008 39.9106H32.122C31.8655 39.9106 31.6586 39.7036 31.6586 39.4472V8.55285C31.6586 8.29642 31.8655 8.08943 32.122 8.08943H38.3008C38.5573 8.08943 38.7642 8.29642 38.7642 8.55285C38.7642 8.80927 38.5573 9.01626 38.3008 9.01626H32.5854V38.9837H38.3008C38.5573 38.9837 38.7642 39.1907 38.7642 39.4472C38.7642 39.7036 38.5573 39.9106 38.3008 39.9106Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9919 8.55285H55.6016V39.4472H75.9919V8.55285Z",
    fill: "#C4BFB6",
    style: {
      fill: "#C4BFB6",
      fill: "color(display-p3 0.7686 0.7490 0.7137)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9919 39.9106H55.6016C55.3452 39.9106 55.1382 39.7036 55.1382 39.4472V8.55285C55.1382 8.29642 55.3452 8.08943 55.6016 8.08943H75.9919C76.2483 8.08943 76.4553 8.29642 76.4553 8.55285V39.4472C76.4553 39.7036 76.2483 39.9106 75.9919 39.9106ZM56.0651 38.9837H75.5285V9.01626H56.0651V38.9837Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6342 8.55285H43.2439V39.4472H63.6342V8.55285Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1545 5.46341V42.5366H66.7236V5.46341H40.1545ZM63.6342 39.4472H43.2439V8.55285H63.6342V39.4472Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7236 43H40.1545C39.8981 43 39.6911 42.793 39.6911 42.5366V5.46341C39.6911 5.20699 39.8981 5 40.1545 5H66.7236C66.98 5 67.187 5.20699 67.187 5.46341V42.5366C67.187 42.793 66.98 43 66.7236 43ZM40.6179 42.0732H66.2602V5.92683H40.6179V42.0732ZM63.6342 39.9106H43.2439C42.9875 39.9106 42.7805 39.7036 42.7805 39.4472V8.55285C42.7805 8.29642 42.9875 8.08943 43.2439 8.08943H63.6342C63.8906 8.08943 64.0976 8.29642 64.0976 8.55285V39.4472C64.0976 39.7036 63.8906 39.9106 63.6342 39.9106ZM43.7073 38.9837H63.1707V9.01626H43.7073V38.9837Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1707 43H2.46343C2.20701 43 2.00002 42.793 2.00002 42.5366C2.00002 42.2802 2.20701 42.0732 2.46343 42.0732H82.1707C82.4272 42.0732 82.6342 42.2802 82.6342 42.5366C82.6342 42.793 82.4272 43 82.1707 43Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassThru);
export default __webpack_public_path__ + "static/media/Pass-thru.8150366532e15d501e33a3aa4d35ab5d.svg";
export { ForwardRef as ReactComponent };